import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, MenuItem, styled } from 'netline-ui';
import { CloseableComponentProps } from 'types';

import styles, { aboutDialogClasses } from './AboutDialog.styles';
import ContentType from './consts';
import GeneralContent from './GeneralContent';
import SupportContent from './SupportContent';
import VersionContent from './VersionContent';

const AboutDialogRoot = styled(Dialog, { name: aboutDialogClasses.$name })(styles);

const contentMap = {
  [ContentType.GENERAL]: GeneralContent,
  [ContentType.VERSIONS]: VersionContent,
  [ContentType.SUPPORT]: SupportContent,
};

const AboutDialog = ({ onMenuClose }: CloseableComponentProps) => {
  const [open, setOpen] = useState(false);
  const [activeContentType, setActiveContentType] = useState(ContentType.GENERAL);
  const { t } = useTranslation();

  const hanldeMenuItemClick = useCallback(() => {
    onMenuClose?.();
    setOpen(true);
  }, [onMenuClose]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      setActiveContentType(ContentType.GENERAL);
    }, 300);
  }, []);

  const handleContentChange = useCallback(
    (newContentType: ContentType | null) => {
      if (!newContentType) {
        handleClose();
        return;
      }
      setActiveContentType(newContentType);
    },
    [handleClose],
  );

  const Content = contentMap[activeContentType] ?? GeneralContent;

  return (
    <>
      <MenuItem onClick={hanldeMenuItemClick} data-testid="AboutDialog-menuItem">
        {t('menu.about')}
      </MenuItem>
      <AboutDialogRoot
        open={open}
        onClose={handleClose}
        className={aboutDialogClasses.root}
        classes={{ paper: aboutDialogClasses.paper }}
        style={{ zIndex: 1320 }}
        scroll="paper"
        data-testid="AboutDialog-root"
      >
        <Content onContentChange={handleContentChange} />
      </AboutDialogRoot>
    </>
  );
};

export default AboutDialog;
